import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-white">
      <header className="h-[84px] bg-black"></header>
      <article className="p-[20px_40px_30px] md:p-[74px_177px_139px]">
        <h1
          style={{ fontFamily: "inter", fontWeight: "bold" }}
          className="font-bold text-[64px] mb-[32px]"
        >
          Terms & Conditions
        </h1>

        <section aria-labelledby="ots-overview">
          <h2 id="ots-overview" className="font-bold text-[20px] m-0">
            OnTheStripTicketing.com: Terms & Conditions
          </h2>
          <span>Powered By Live on Beat LLC</span>
          <p className="font-medium text-[16px] mt-0">
            By purchasing tickets through this website and system (“Service”),
            you agree to be bound by these Terms & Conditions (“Agreement”).
            This Agreement is a binding legal contract between you (“User”),
            OnTheStripTicketing.com (“Organizer,” “we,” “us,” or “our”), and
            Live on Beat LLC (“LOB”), the platform powering this ticketing
            service. If you do not agree, do not complete your purchase.
          </p>
        </section>

        <section aria-labelledby="role-lob">
          <h2 id="role-lob" className="font-bold text-[20px] m-0">
            1. Role of Live on Beat (LOB)
          </h2>
          <p className="font-medium text-[16px] mt-0">
            Live on Beat LLC provides the white-label ticketing software used by
            OnTheStripTicketing.com to manage and sell tickets for events. LOB
            is a technology provider only and not the event organizer, promoter,
            or ticket seller. You transact directly with OnTheStripTicketing.com
            when purchasing a ticket. LOB is not responsible for the event.
          </p>
        </section>

        <section aria-labelledby="organizer-responsibility">
          <h2
            id="organizer-responsibility"
            className="font-bold text-[20px] m-0"
          >
            2. Organizer’s Responsibility
          </h2>
          <ul className="font-medium text-[16px] list-disc">
            <li>Planning, promoting, and executing the event.</li>
            <li>Setting entry policies, pricing, and ticket limits.</li>
            <li>
              Providing products, services, or experiences related to the event.
            </li>
            <li>Determining and managing refund or cancellation policies.</li>
          </ul>
          <p className="font-medium text-[16px] mt-0">
            LOB does not verify or guarantee the quality, safety, legality, or
            accuracy of any event information or experience.
          </p>
        </section>

        <section aria-labelledby="liability">
          <h2 id="liability" className="font-bold text-[20px] m-0">
            3. No Liability (LOB & OnTheStripTicketing.com)
          </h2>
          <ul className="font-medium text-[16px] list-disc">
            <li>Event changes, delays, or cancellations.</li>
            <li>Denied entry or issues related to ticket usage.</li>
            <li>
              Injuries, damages, illnesses, or losses incurred at or in
              connection with the event.
            </li>
            <li>
              Errors, malfunctions, or security issues in the ticketing process.
            </li>
            <li>Refunds or disputes: handled solely by the Organizer.</li>
          </ul>
          <p className="font-medium text-[16px] mt-0">
            Attending the event is at your own risk.
          </p>
        </section>

        <section aria-labelledby="indemnification">
          <h2 id="indemnification" className="font-bold text-[20px] m-0">
            4. Indemnification
          </h2>
          <p className="font-medium text-[16px] mt-0">
            You agree to indemnify, defend, and hold harmless both
            OnTheStripTicketing.com and LOB from any claims, damages, losses, or
            legal expenses resulting from:
          </p>
          <ul className="font-medium text-[16px] list-disc">
            <li>Your actions or use of the Service.</li>
            <li>Breach of this Agreement.</li>
            <li>Disputes with the Organizer, venue, or third parties.</li>
          </ul>
        </section>

        <section aria-labelledby="refunds-cancellations">
          <h2 id="refunds-cancellations" className="font-bold text-[20px] m-0">
            5. Refunds and Cancellations
          </h2>
          <p className="font-medium text-[16px] mt-0">
            OnTheStripTicketing.com sets all refund and cancellation policies.
            Disputes regarding tickets, event changes, or rescheduling must be
            handled directly with the Organizer. LOB is not responsible for
            refund decisions or customer service issues related to the event.
          </p>
        </section>

        <section aria-labelledby="no-warranties">
          <h2 id="no-warranties" className="font-bold text-[20px] m-0">
            6. No Warranties
          </h2>
          <ul className="font-medium text-[16px] list-disc">
            <li>Fitness for a particular purpose.</li>
            <li>Event outcome or experience quality.</li>
            <li>Accuracy of event listings or ticket availability.</li>
            <li>
              Availability or performance of the website or ticketing system.
            </li>
          </ul>
        </section>

        <section aria-labelledby="limitation-liability">
          <h2 id="limitation-liability" className="font-bold text-[20px] m-0">
            7. Limitation of Liability
          </h2>
          <p className="font-medium text-[16px] mt-0">
            The total liability of OnTheStripTicketing.com and/or LOB is limited
            to the amount you paid for your ticket, or $100 USD, whichever is
            lower. Neither party is liable for indirect or consequential damages
            (e.g., lost income or travel costs).
          </p>
        </section>

        <section aria-labelledby="dispute-resolution">
          <h2 id="dispute-resolution" className="font-bold text-[20px] m-0">
            8. Dispute Resolution
          </h2>
          <ul className="font-medium text-[16px] list-disc">
            <li>
              Disputes with LOB will be resolved via binding arbitration in
              Clark County, Nevada under AAA rules.
            </li>
            <li>
              You waive your right to participate in class action lawsuits.
            </li>
            <li>
              Injunctive relief may be pursued for IP or confidentiality
              violations.
            </li>
          </ul>
        </section>

        <section aria-labelledby="force-majeure">
          <h2 id="force-majeure" className="font-bold text-[20px] m-0">
            9. Force Majeure
          </h2>
          <p className="font-medium text-[16px] mt-0">
            Neither party is responsible for failures due to circumstances
            beyond reasonable control such as natural disasters, pandemics, or
            technical failures.
          </p>
        </section>

        <section aria-labelledby="privacy">
          <h2 id="privacy" className="font-bold text-[20px] m-0">
            10. Privacy
          </h2>
          <ul className="font-medium text-[16px] list-disc">
            <li>
              Data may be shared between LOB and the Organizer for communication
              and service.
            </li>
            <li>
              Payments are securely processed by third parties like Stripe. Card
              details are not stored.
            </li>
            <li>Organizer is responsible for data usage post-purchase.</li>
          </ul>
        </section>

        <section aria-labelledby="modification-terms">
          <h2 id="modification-terms" className="font-bold text-[20px] m-0">
            11. Modification of Terms
          </h2>
          <p className="font-medium text-[16px] mt-0">
            Terms may be updated at any time by either LOB or the Organizer.
            Continued use of the Service means you accept the updated Terms.
          </p>
        </section>

        <section aria-labelledby="severability">
          <h2 id="severability" className="font-bold text-[20px] m-0">
            12. Severability
          </h2>
          <p className="font-medium text-[16px] mt-0">
            If any part of this Agreement is found invalid or unenforceable, the
            rest shall remain in effect.
          </p>
        </section>

        <section aria-labelledby="contact-info">
          <h2 id="contact-info" className="font-bold text-[20px] m-0">
            13. Contact Information
          </h2>
          <p className="font-medium text-[16px]">
            Event-related questions:{" "}
            <a
              href="mailto:Dean@sprpromotions.com"
              className="font-bold italic text-black"
            >
              Dean@sprpromotions.com
            </a>
          </p>
          <p className="font-medium text-[16px]">
            Technical support:{" "}
            <a
              href="mailto:info@liveonbeat.com"
              className="font-bold italic text-black"
            >
              info@liveonbeat.com
            </a>
          </p>
        </section>

        <section aria-labelledby="acknowledgment">
          <h2 id="acknowledgment" className="font-bold text-[20px] m-0">
            14. Acknowledgment
          </h2>
          <ul className="font-medium text-[16px] list-disc">
            <li>You reviewed and accepted these Terms.</li>
            <li>
              You acknowledge OnTheStripTicketing.com is the Organizer and
              ticket seller.
            </li>
            <li>
              You waive legal claims against LOB regarding the event experience.
            </li>
          </ul>
        </section>

        <section aria-labelledby="entry-policy">
          <h2 id="entry-policy" className="font-bold text-[20px] m-0">
            15. Event Entry Policy
          </h2>
          <p className="font-medium text-[16px] mt-0">
            Bring a valid digital/printed ticket and government ID if required.
            Entry is subject to venue/Organizer rules.
          </p>
        </section>

        <section aria-labelledby="ticket-transfer">
          <h2 id="ticket-transfer" className="font-bold text-[20px] m-0">
            16. Ticket Resale & Transfer
          </h2>
          <p className="font-medium text-[16px] mt-0">
            Tickets are non-transferable unless approved by the Organizer.
            Resale is not supported or validated by LOB.
          </p>
        </section>

        <section aria-labelledby="age-restrictions">
          <h2 id="age-restrictions" className="font-bold text-[20px] m-0">
            17. Age Restrictions
          </h2>
          <p className="font-medium text-[16px] mt-0">
            Some events may be 18+ or 21+. No refunds if entry is denied due to
            age.
          </p>
        </section>
      </article>
    </main>
  );
}

export default Terms;
